<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="name"
            clear-icon="mdi-close"
            label="Tên kỳ nghỉ"
            flat
            outlined
            dense
            clearable
            hide-details
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <date-picker
            :date.sync="startDate"
            label="Từ ngày"
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" md="4">
          <date-picker
            :date.sync="endDate"
            label="Đến ngày"
            outlined
            dense
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>Tìm kiếm</v-btn>
    </div>
  </div>
</template>

<script>

import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'
import moment from 'moment'

export default {
  components: {
    DatePicker,
  },
  data: () => ({
    name: '',
    startDate: '',
    endDate: '',
  }),
  methods: {
    onFilterChanged() {
      const params = {
        name_contains: this.name,
        startDate_gte: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : undefined,
        endDate_lte: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : undefined,
      }
      this.$emit('onFilterChanged', params)
    },

  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
